import { useBeds } from "@/hooks/useBeds";
import { Additional, ReactSelect, ReactSelectProps } from "../ReactSelect";
import { BedStatus } from "@/enums/BedStatus";

export function BedsSelect({ ...rest }: ReactSelectProps) {
	const { getSurgicalBeds } = useBeds();

	const loadAsyncBedOptionsProps = {
		additional: { page: 1 },
		isAsyncPaginate: true,
		async loadOptions(search: string, _: Bed, { page }: Additional) {
			const beds = await getSurgicalBeds(page, search);
			const meta = beds.meta;
			const filteredBeds = beds.results.filter((bed) => bed.status === BedStatus.AVAILABLE);

			return {
				options: filteredBeds.map((bed) => ({ value: bed.id, label: bed.fullName })),
				hasMore: meta?.currentPage < meta?.lastPage,
				additional: { page: page + 1 },
			};
		},
	};

	return <ReactSelect isSolid {...loadAsyncBedOptionsProps} {...rest} />;
}
